import { Dialog, FormHelperText, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useForm, useFieldArray } from "react-hook-form";
import { StyledButton } from "../../../common/components/Button";
import { InputLabel } from "../../../common/components/InputLabel";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { uploadFiles } from "../../../api/caseApi";
import { deepPurple, grey } from "@mui/material/colors";
import { DialogHeader } from "../styles";
import { MenuItem } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Controller } from "react-hook-form";
import { CircularProgress } from "@mui/material";
import { Grid } from "@mui/material";
import { StyledLink } from "../../../common/components/Title/styles";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const UploadFilesDialog = ({
  open,
  onClose,
  caseId,
  scanningId,
  designId,
  reviewDesignId,
  fetchFiles,
}) => {
  const types = [
    { name: "Ios Scan", type: 1, caseProgressId: scanningId },
    { name: "Clinical Photography", type: 2, caseProgressId: scanningId },
    { name: "Additional File", type: 3, caseProgressId: scanningId },
    { name: "Design File", type: 4, caseProgressId: designId },
    { name: "Additional on Reject", type: 4, caseProgressId: reviewDesignId },
  ];
  const [caseProgressId, setCaseProgressId] = useState("");
  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    trigger,
    control,
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        fileType: yup.number().required("File type is required"),
        files: yup.array().of(yup.mixed()).required("Files is required."),
      })
    ),
  });
  const { append, remove } = useFieldArray({
    control,
    name: "files",
  });
  const fileType = watch("fileType");
  const files = watch("files");

  const { getRootProps, getInputProps } = useDropzone({
    disabled: !fileType,
    accept: {
      ...(fileType === 1 && { "application/octet-stream": [".stl"] }),
      ...(fileType === 2 && {
        "image/jpeg": [".jpg", ".jpeg"],
        "image/png": [".png"],
      }),
    },
    onDropAccepted: (files) => {
      files.map((file) =>
        append({
          file: file,
          type: fileType,
          subType: 0,
        })
      );

      trigger("files");
    },
  });

  useEffect(() => {
    if (open === false) {
      reset();
    }
  }, [open, reset]);

  console.log(errors);
  const handleRemoveFile = (index) => {
    remove(index);
  };
  const handleDesignSubmit = async (values) => {
    const formData = new FormData();
    formData.append("type", values.fileType);
    formData.append("caseId", caseId);
    formData.append("caseProgressId", caseProgressId);
    values.files.forEach((fileDetails) => {
      formData.append("files", fileDetails.file);
    });
    console.log(values.files);

    try {
      await uploadFiles(formData);
      await fetchFiles();
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <Dialog open={isSubmitting}>
        <Box sx={{ paddingX: 10, paddingY: 10 }}>
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
          <Typography sx={{ marginTop: 4, color: grey[600] }}>
            Please wait while we process your request.
          </Typography>
        </Box>
      </Dialog>
      <Box
        component="form"
        onSubmit={handleSubmit(handleDesignSubmit)}
        sx={{ px: 3, py: 2 }}
      >
        <DialogHeader>Upload Files</DialogHeader>
        <br />
        <Box>
          <Box component="h4">File Type</Box>
          <Controller
            control={control}
            name="fileType"
            render={({ field: { onChange }, fieldState: { error } }) => (
              <Autocomplete
                autoHighlight
                disablePortal
                options={types}
                onChange={(_, val) => {
                  onChange(val?.type || "");
                  setCaseProgressId(val?.caseProgressId);
                }}
                getOptionLabel={(option) => option.name || option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={Boolean(error)}
                    FormHelperTextProps={{ variant: "standard" }}
                    helperText={error && error.message}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.type}>
                      {option.name}
                    </li>
                  );
                }}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Box>
        <Box {...getRootProps()}>
          <input {...getInputProps()} />
          <Box component="h4">Files</Box>
          <Box
            sx={{
              cursor: fileType ? "pointer" : "default",
              padding: 4,
              border: "1px dashed " + grey[400],

              backgroundColor: grey[100],
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: fileType ? grey[200] : grey[100],
                borderColor: fileType ? deepPurple[400] : grey[400],
              },
            }}
          >
            Select or drag file/s
          </Box>
          <FormHelperText error variant="outlined">
            {Boolean(errors.files) && errors.files.message}
          </FormHelperText>
        </Box>
        <Box sx={{ marginTop: 1 }}>
          <Box component="h4">Selected Files</Box>

          {files &&
            files.map((fileDetails, idx) => (
              <Grid container height={"20px"}>
                <Grid item xs={7}>
                  <Typography
                    key={JSON.stringify(fileDetails)}
                    sx={{ color: grey[600] }}
                  >
                    {fileDetails.file.name}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => handleRemoveFile(idx)}
                    style={{
                      cursor: "pointer",
                      color: "#808080",
                      width: "14px",
                      height: "14px",
                      "&:hover": {
                        backgroundColor: "red",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            ))}
        </Box>

        <Box
          sx={{
            display: "flex",
            paddingTop: 2,
          }}
        >
          <StyledButton
            type="button"
            theme="purple"
            sx={{ marginLeft: "auto" }}
            disabled={isSubmitting}
            onClick={onClose}
          >
            Cancel
          </StyledButton>
          <StyledButton
            type="submit"
            theme="green"
            sx={{ marginLeft: 1.5 }}
            disabled={isSubmitting}
          >
            Submit
          </StyledButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default UploadFilesDialog;
